export const paymentForm = {
  payment: 'Paiement',
  choosePaymentMethod: 'Choisissez un mode de paiement',
  paymentType: 'Type de paiement',
  accountHolderName: {
    label: 'Nom du titulaire du compte',
    placeholder: 'Nom du titulaire du compte',
  },
  cardNumber: 'Numéro de carte',
  expirationDate: 'Date d\'expiration',
  securityCode: 'Code de sécurité (CVV)',
  securityCodeTitle: 'Valeur de vérification de la carte',
  saveAsDefault: 'Sauvegarder par défaut',
  setAsDefault: 'Définir par défaut',
  billingAddress: 'Adresse de facturation',
  sameAsShippingAddress: 'Identique à l\'adresse de livraison',
  selectOne: 'Sélectionner...',
  monthMask: 'MM',
  yearMask: 'AAAA',
  useThisPayment: 'Utiliser ce paiement',
  addNewPayment: 'Ajouter un nouveau paiement',
  changePayment: 'Modifier le paiement',
};
export const paymentMethods = {
  paymentMethods: 'Modes de paiement',
  newPaymentMethodsAreAddedDuringCheckout: 'Les nouveaux modes de paiement sont ajoutés lors du passage à la caisse.',
  invalidField: 'Champ invalide : {{ field }}',
};
export const paymentCard = {
  deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer ce mode de paiement?',
  setAsDefault: 'Définir par défaut',
  expires: 'Expire : {{ month }}/{{ year }}',
  defaultPaymentMethod: '✓ PAR DÉFAUT',
  selected: 'Sélectionné',
  cardType: 'Type de carte : {{ type }}',
};
export const paymentTypes = {
  title: 'Mode de paiement',
  paymentType_CARD: 'Carte de crédit',
  paymentType_ACCOUNT: 'Compte',
  paymentTerms: 'Modalités de paiement',
  paymentTermsDays: '30 jours',
};

export const payment = {
  paymentForm,
  paymentMethods,
  paymentCard,
  paymentTypes,
};
